__turbopack_context__.v({
  "root": "styles-module-scss-module__wuVlmG__root",
  "root3D": "styles-module-scss-module__wuVlmG__root3D",
});
